import axios from 'axios';
import BaseAPI from './base/base-api';

class ColumnExportAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'columnexport';
}

export default new ColumnExportAPI();
